// extracted by mini-css-extract-plugin
export default {"addDocs":"myDocumentContainer_addDocs__j5jw9","requiredDocs":"myDocumentContainer_requiredDocs__5OaSW","padding":"myDocumentContainer_padding__xk42Z"};